import React, { useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import api from "../../../api/axiosInstance";
const MethodologySection = () => {
  const [methodologySteps, setMethodologySteps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMethodology = async () => {
      try {
        const res = await api.fetch("/api/methodology");
        const result = await res.json();

        if (result.success) {
          // 🔥 Ensure data is ALWAYS an array
          const dataArray = Array.isArray(result.data)
            ? result.data
            : [result.data];

          const formattedData = dataArray.map((item) => ({
            id: item._id,
            phaseNumber: item.phaseNumber,
            icon: item.icon || "Target",
            title: item.title,
            description: item.description,
            features: item.keyPoints || []
          }));

          // Sort by phase number
          formattedData.sort((a, b) => a.phaseNumber - b.phaseNumber);

          setMethodologySteps(formattedData);
        }
      } catch (error) {
        console.error("Failed to fetch methodology", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMethodology();
  }, []);

  if (loading) {
    return <p className="text-center py-10">Loading methodology...</p>;
  }

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">

        {/* HEADER */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Lightbulb" size={20} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">
              Our Methodology
            </span>
          </div>

          <h2 className="text-3xl font-heading font-bold text-foreground mb-4">
            Science-Backed Approach to Interview Success
          </h2>

          <p className="text-muted-foreground max-w-3xl mx-auto">
            Our structured methodology evolves dynamically from the backend.
          </p>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {methodologySteps.map((step, index) => (
            <div
              key={step.id}
              className="relative bg-card p-8 rounded-xl border border-border hover:shadow-lg transition-base"
            >
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold text-lg">
                {index + 1}
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Icon name={step.icon} size={24} color="var(--color-primary)" />
                </div>

                <div className="flex-1 space-y-4">
                  <h3 className="text-xl font-heading font-bold">
                    {step.title}
                  </h3>

                  <p className="text-muted-foreground">
                    {step.description}
                  </p>

                  <ul className="space-y-2">
                    {step.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="flex items-center space-x-2"
                      >
                        <Icon
                          name="CheckCircle2"
                          size={16}
                          color="var(--color-success)"
                        />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default MethodologySection;
